import { strapiTrainingService } from "../../../services/api/strapiTraining";

// Fonction pour mettre à jour la visibilité des chapitres
export const updateVisibleChapters = (trainingDetails, activeChapterId, setVisibleChapters) => {
    const newVisibleChapters = {};
    trainingDetails.chapters?.forEach(chapter => {
        newVisibleChapters[chapter.id] = chapter.id === activeChapterId;
    });
    setVisibleChapters(newVisibleChapters);
};

// Fonction pour gérer le clic sur une leçon
export const handleLessonClick = (
    trainingDetails,
    chapter,
    lesson,
    setSelectedTrainingChapter,
    setSelectedTrainingLesson,
    updateVisibleChapters,
    setVisibleChapters,
    setDisplayedMobileMenu,
    contentRef,
    titleRef,
    isMobile
) => {
    setSelectedTrainingChapter(chapter);
    setSelectedTrainingLesson(lesson);
    updateVisibleChapters(trainingDetails, chapter.id, setVisibleChapters);
    setDisplayedMobileMenu(false);

    if (!isMobile) {
        if (titleRef && titleRef.current) {
            titleRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    } else if (contentRef && contentRef.current) {
        contentRef.current.scrollIntoView({ behavior: 'smooth' });
    }
};

// Fonction pour basculer la visibilité d'un chapitre
export const toggleChapterVisibility = (chapterId, setVisibleChapters) => {
    setVisibleChapters(prevState => ({
        ...prevState,
        [chapterId]: !prevState[chapterId]
    }));
};

// Fonction pour naviguer vers la leçon précédente
export const navigateToPreviousLesson = (
    selectedTrainingChapter,
    selectedTrainingLesson,
    trainingDetails,
    handleLessonClickCallback
) => {
    if (!selectedTrainingChapter || !selectedTrainingLesson || !trainingDetails.chapters) {
        return;
    }

    const currentLessonIndex = selectedTrainingChapter.lessons?.findIndex(lesson => lesson.id === selectedTrainingLesson.id);
    
    if (currentLessonIndex > 0) {
        // Il y a une leçon précédente dans le même chapitre
        const previousLesson = selectedTrainingChapter.lessons[currentLessonIndex - 1];
        handleLessonClickCallback(selectedTrainingChapter, previousLesson);
    } else {
        // Aller au dernier leçon du chapitre précédent
        const previousChapterIndex = trainingDetails.chapters.findIndex(chapter => chapter.id === selectedTrainingChapter.id) - 1;
        if (previousChapterIndex >= 0) {
            const previousChapter = trainingDetails.chapters[previousChapterIndex];
            const previousChapterLastLesson = previousChapter.lessons?.[previousChapter.lessons.length - 1];
            if (previousChapterLastLesson) {
                handleLessonClickCallback(previousChapter, previousChapterLastLesson);
            }
        }
    }
};

// Fonction pour naviguer vers la leçon suivante
export const navigateToNextLesson = (
    selectedTrainingChapter,
    selectedTrainingLesson,
    trainingDetails,
    handleLessonClickCallback
) => {
    if (!selectedTrainingChapter || !selectedTrainingLesson || !trainingDetails.chapters) {
        return;
    }

    const currentLessonIndex = selectedTrainingChapter.lessons?.findIndex(lesson => lesson.id === selectedTrainingLesson.id);
    
    if (currentLessonIndex < (selectedTrainingChapter.lessons?.length - 1)) {
        // Il y a une leçon suivante dans le même chapitre
        const nextLesson = selectedTrainingChapter.lessons[currentLessonIndex + 1];
        handleLessonClickCallback(selectedTrainingChapter, nextLesson);
    } else {
        // Aller à la première leçon du chapitre suivant
        const nextChapterIndex = trainingDetails.chapters.findIndex(chapter => chapter.id === selectedTrainingChapter.id) + 1;
        if (nextChapterIndex < trainingDetails.chapters.length) {
            const nextChapter = trainingDetails.chapters[nextChapterIndex];
            const nextChapterFirstLesson = nextChapter.lessons?.[0];
            if (nextChapterFirstLesson) {
                handleLessonClickCallback(nextChapter, nextChapterFirstLesson);
            }
        }
    }
};

// Fonction pour créer une clé unique pour une leçon basée sur l'ordre du chapitre et de la leçon
export const createLessonKey = (chapter, lesson) => {
    const key = `${chapter.order_nb}-${lesson.order_nb}`;
    console.log('createLessonKey:', { chapter: chapter.order_nb, lesson: lesson.order_nb, key });
    return key;
};

// Nouvelle fonction pour mapper les données de progression intégrées vers le format attendu
export const mapProgressDataToCompletedLessons = (progressChapters) => {
    console.log('=== mapProgressDataToCompletedLessons ===');
    console.log('progressChapters reçus:', progressChapters);
    
    const completedLessonsMap = {};
    
    if (!progressChapters || !Array.isArray(progressChapters)) {
        console.log('Aucune donnée de progression des chapitres');
        return completedLessonsMap;
    }

    progressChapters.forEach(progressChapter => {
        console.log('Traitement du chapitre progression:', progressChapter.order);
        
        if (progressChapter.lessons && Array.isArray(progressChapter.lessons)) {
            progressChapter.lessons.forEach(progressLesson => {
                const lessonKey = `${progressChapter.order}-${progressLesson.order}`;
                completedLessonsMap[lessonKey] = progressLesson.completed;
                console.log(`Mapping leçon ${lessonKey}: ${progressLesson.completed}`);
            });
        }
    });
    
    console.log('Résultat mapping:', completedLessonsMap);
    return completedLessonsMap;
};

// Fonction pour mettre à jour les données de progression après un changement
export const updateProgressionAfterToggle = (
    responseData,
    setCompletedLessons,
    setTrainingProgress,
    selectedTrainingChapter,
    selectedTrainingLesson
) => {
    console.log('=== updateProgressionAfterToggle ===');
    console.log('responseData:', responseData);
    
    if (responseData?.data) {
        const lessonKey = createLessonKey(selectedTrainingChapter, selectedTrainingLesson);
        
        console.log('Mise à jour de la leçon:', lessonKey, 'vers:', responseData.data.lessonCompleted);
        
        // Mettre à jour l'état de la leçon
        setCompletedLessons(prevState => {
            const newState = {
                ...prevState,
                [lessonKey]: responseData.data.lessonCompleted
            };
            console.log('Nouvel état completedLessons:', newState);
            return newState;
        });
        
        // Mettre à jour la progression globale
        const newProgress = responseData.data.progressPercentage || 0;
        console.log('Mise à jour progression globale:', newProgress);
        setTrainingProgress(newProgress);
    }
};

// Fonction pour basculer l'achèvement d'une leçon
export const toggleLessonCompletion = async (
    trainingId,
    selectedTrainingChapter,
    selectedTrainingLesson,
    trainingDetails,
    setSelectedTrainingChapter,
    setSelectedTrainingLesson,
    setCompletedLessons,
    setTrainingProgress,
    updateVisibleChapters,
    setVisibleChapters,
    setDisplayedMobileMenu,
    contentRef,
    titleRef,
    isMobile,
    wasCompleted = false
) => {
    console.log('=== toggleLessonCompletion ===');
    console.log('Paramètres:', {
        trainingId,
        chapterOrder: selectedTrainingChapter?.order_nb,
        lessonOrder: selectedTrainingLesson?.order_nb,
        wasCompleted
    });
    
    try {
        if (!trainingId || !selectedTrainingChapter || !selectedTrainingLesson) {
            throw new Error('Données de formation manquantes');
        }

        console.log('Appel API strapiTrainingService.toggleLessonProgress...');
        
        // Appeler l'API pour basculer le statut de la leçon
        const response = await strapiTrainingService.toggleLessonProgress(
            trainingId,
            selectedTrainingChapter.order_nb,
            selectedTrainingLesson.order_nb
        );

        console.log('Réponse API:', response);

        // Mettre à jour l'état local
        updateProgressionAfterToggle(
            response,
            setCompletedLessons,
            setTrainingProgress,
            selectedTrainingChapter,
            selectedTrainingLesson
        );
        
        // Si la leçon vient d'être marquée comme terminée (et n'était pas déjà terminée)
        if (response?.data?.lessonCompleted && !wasCompleted) {
            console.log('Leçon marquée comme terminée, navigation vers la suivante dans 500ms...');
            // Naviguer vers la leçon suivante après un court délai
            setTimeout(() => {
                navigateToNextLesson(
                    selectedTrainingChapter,
                    selectedTrainingLesson,
                    trainingDetails,
                    (chapter, lesson) => handleLessonClick(
                        trainingDetails,
                        chapter,
                        lesson,
                        setSelectedTrainingChapter,
                        setSelectedTrainingLesson,
                        updateVisibleChapters,
                        setVisibleChapters,
                        setDisplayedMobileMenu,
                        contentRef,
                        titleRef,
                        isMobile
                    )
                );
            }, 500);
        }
        
        return response;
    } catch (error) {
        console.error('Erreur dans toggleLessonCompletion:', error);
        throw error;
    }
};

// Fonction pour récupérer la progression d'une formation (maintenant simplifiée)
export const fetchTrainingProgress = async (
    trainingId,
    setCompletedLessons,
    setTrainingProgress,
    setError = null
) => {
    console.log('=== fetchTrainingProgress ===');
    console.log('trainingId:', trainingId);
    
    try {
        if (!trainingId) {
            throw new Error('ID de formation requis');
        }

        console.log('Appel API getTrainingProgress...');
        const response = await strapiTrainingService.getTrainingProgress(trainingId);
        console.log('Réponse API getTrainingProgress:', response);
        
        // Transformer les données de progression
        const progressData = transformProgressionData(response);
        
        // Mettre à jour les états
        setCompletedLessons(progressData.completedLessons);
        setTrainingProgress(progressData.progress);
        
        console.debug('Progression de formation chargée:', progressData);
        
        return progressData;
    } catch (error) {
        console.error('Erreur dans fetchTrainingProgress:', error);
        if (setError) {
            setError(error.message);
        }
        throw error;
    }
};

// Fonction pour transformer les données de progression de l'API vers le format attendu par l'interface
export const transformProgressionData = (progressData) => {
    console.log('=== transformProgressionData ===');
    console.log('progressData reçu:', progressData);
    
    const completedLessonsMap = {};
    
    if (progressData?.data?.chapters) {
        progressData.data.chapters.forEach(chapter => {
            console.log('Traitement du chapitre:', chapter.order);
            chapter.lessons?.forEach(lesson => {
                const key = `${chapter.order}-${lesson.order}`;
                completedLessonsMap[key] = lesson.completed;
                console.log(`Leçon ${key}: ${lesson.completed ? 'terminée' : 'non terminée'}`);
            });
        });
    }
    
    const result = {
        completedLessons: completedLessonsMap,
        progress: progressData?.data?.progressPercentage || 0,
        totalLessons: progressData?.data?.totalLessons || 0,
        completedLessonsCount: progressData?.data?.completedLessons || 0
    };
    
    console.log('Résultat transformation:', result);
    return result;
};

// Fonction pour mapper les leçons avec leur progression lors du chargement initial (adaptée pour la nouvelle structure)
export const mapLessonsWithProgress = (trainingDetails, progressData) => {
    console.log('=== mapLessonsWithProgress ===');
    console.log('trainingDetails:', trainingDetails);
    console.log('progressData:', progressData);
    
    if (!progressData?.data?.chapters || !trainingDetails?.chapters) {
        console.log('Données manquantes pour le mapping');
        return {};
    }

    const completedLessonsMap = {};
    
    trainingDetails.chapters.forEach(trainingChapter => {
        console.log('Traitement du chapitre formation:', trainingChapter.order_nb);
        
        // Trouver le chapitre correspondant dans les données de progression
        const progressChapter = progressData.data.chapters.find(
            progChapter => progChapter.order === trainingChapter.order_nb
        );
        
        if (progressChapter && trainingChapter.lessons) {
            console.log('Chapitre trouvé dans progression:', progressChapter.order);
            
            trainingChapter.lessons.forEach(trainingLesson => {
                console.log('Traitement de la leçon formation:', trainingLesson.order_nb);
                
                // Trouver la leçon correspondante dans les données de progression
                const progressLesson = progressChapter.lessons?.find(
                    progLesson => progLesson.order === trainingLesson.order_nb
                );
                
                if (progressLesson) {
                    const lessonKey = createLessonKey(trainingChapter, trainingLesson);
                    completedLessonsMap[lessonKey] = progressLesson.completed;
                    console.log(`Mapping leçon ${lessonKey}: ${progressLesson.completed}`);
                } else {
                    console.log('Leçon progression non trouvée pour:', trainingLesson.order_nb);
                }
            });
        } else {
            console.log('Chapitre progression non trouvé pour:', trainingChapter.order_nb);
        }
    });
    
    console.log('Résultat mapping:', completedLessonsMap);
    return completedLessonsMap;
};

/**
 * Trouve la première leçon non terminée dans une formation
 * @param {Object} trainingDetails - Les détails de la formation avec chapitres et leçons
 * @param {Object} completedLessonsMap - Map des leçons terminées (clé: "chapterOrder-lessonOrder", valeur: boolean)
 * @returns {Object|null} - Objet avec { chapter, lesson } ou null si toutes les leçons sont terminées
 */
export const findFirstIncompleteLesson = (trainingDetails, completedLessonsMap) => {
    console.log('=== findFirstIncompleteLesson ===');
    console.log('trainingDetails:', trainingDetails);
    console.log('completedLessonsMap:', completedLessonsMap);
    
    if (!trainingDetails?.chapters || !Array.isArray(trainingDetails.chapters)) {
        console.log('Aucun chapitre trouvé');
        return null;
    }

    // Parcourir tous les chapitres dans l'ordre
    for (const chapter of trainingDetails.chapters.sort((a, b) => a.order_nb - b.order_nb)) {
        console.log(`Examen du chapitre ${chapter.order_nb}: ${chapter.title}`);
        
        if (!chapter.lessons || !Array.isArray(chapter.lessons)) {
            console.log(`Aucune leçon dans le chapitre ${chapter.order_nb}`);
            continue;
        }

        // Parcourir toutes les leçons du chapitre dans l'ordre
        for (const lesson of chapter.lessons.sort((a, b) => a.order_nb - b.order_nb)) {
            const lessonKey = createLessonKey(chapter, lesson);
            const isCompleted = completedLessonsMap[lessonKey] || false;
            
            console.log(`Leçon ${lessonKey} (${lesson.title}): ${isCompleted ? 'terminée' : 'non terminée'}`);
            
            // Si on trouve une leçon non terminée, on la retourne
            if (!isCompleted) {
                console.log(`✅ Première leçon non terminée trouvée: ${lessonKey} - ${lesson.title}`);
                return {
                    chapter,
                    lesson
                };
            }
        }
    }

    console.log('Toutes les leçons sont terminées');
    return null;
};

/**
 * Fonction pour obtenir la leçon par défaut à afficher lors du chargement
 * @param {Object} trainingDetails - Les détails de la formation
 * @param {Object} completedLessonsMap - Map des leçons terminées
 * @returns {Object|null} - Objet avec { chapter, lesson } ou null
 */
export const getDefaultLessonToDisplay = (trainingDetails, completedLessonsMap) => {
    console.log('=== getDefaultLessonToDisplay ===');
    
    // D'abord essayer de trouver la première leçon non terminée
    const firstIncompleteLesson = findFirstIncompleteLesson(trainingDetails, completedLessonsMap);
    
    if (firstIncompleteLesson) {
        console.log('Leçon par défaut: première leçon non terminée');
        return firstIncompleteLesson;
    }

    // Si toutes les leçons sont terminées, prendre la première leçon du premier chapitre
    console.log('Toutes les leçons sont terminées, sélection de la première leçon');
    const firstChapter = trainingDetails.chapters?.find(chapter => chapter.order_nb === 1);
    if (firstChapter) {
        const firstLesson = firstChapter.lessons?.find(lesson => lesson.order_nb === 1);
        if (firstLesson) {
            return {
                chapter: firstChapter,
                lesson: firstLesson
            };
        }
    }

    console.log('Aucune leçon trouvée');
    return null;
};